<template>
  <div class="fill-height align-content-center">
    <template v-if="manager.loading">
      <v-skeleton-loader type="card" />
    </template>
    <v-card v-else class="rounded-xl card-border-red h-100 pa-4">
      <v-row
        v-if="!manager.error"
        class="fill-height align-center justify-center pa-2"
      >
        <v-col>
          <div class="mb-2 d-flex flex-column">
            <span class="text-subtitle-2 w-100 font-weight-bold">
              {{ `${manager.data.zoneId} | ${manager.data.zoneFullDesc}` }}
            </span>
            <span class="text-body-2 text-left justify-center text-none">
              {{ `${manager.data?.user?.id} | ${manager.data?.user.name}`
              }}<data-update-step-launcher
                v-if="$hasAnyRole(['Manager', 'Submanager'])"
                :size="19"
              />
            </span>
          </div>
        </v-col>
        <v-col cols="12" class="pa-0 mb-1">
          <div class="w-100 d-flex align-center justify-end">
            <a @click="getCustomersLocation">
              <svg-icon name="maps-icon" size="30" />
            </a>
            <router-link :to="{ name: 'PlaneadorManager' }">
              <v-icon color="blue" size="30">mdi-calendar-check-outline</v-icon>
            </router-link>
            <sales-policy-file-downloader
              class="mx-1"
              icon-size="30"
              policy-type="car"
              :icon-class="
                manager.data.hasCar > 0
                  ? 'car-policy-enabled'
                  : 'car-policy-disabled'
              "
            />
            <sales-policy-file-downloader
              icon-size="30"
              policy-type="delivery"
            />
            <sales-policy-file-downloader
              icon-size="30"
              policy-type="sellCredit"
            />
            <i-u-s-a-training :user-id="manager.data?.user?.id" size="40" />
          </div>
        </v-col>
        <v-col cols="12" class="text-body-2 pa-0 mb-1">
          <div class="d-flex w-100">
            <div class="text-left">
              <b>Antigüedad:</b> <br />
              IUSA: {{ seniorityIUSA }}
            </div>
          </div>
        </v-col>
        <v-col cols="12" class="pa-0">
          <div
            class="d-flex gap-1 align-center"
            :class="
              isManager
                ? 'flex-wrap justify-space-between'
                : 'flex-nowrap justify-end'
            "
          >
            <change-password-control v-if="isManager" />
            <sales-per-capita
              :chnl="manager.data?.user?.channel"
              :user-code="manager.data?.user?.id"
              scope="manager"
              :billed-amount="Number(manager.data?.billingLastMonth ?? 0)"
            />
          </div>
        </v-col>
      </v-row>
      <alert-prominent
        v-if="manager.error"
        :message="manager.error"
        :with-action="true"
      />
    </v-card>
    <customer-locations-map
      v-model="openMap"
      :type="typeCustomerLocation"
      :customers="customersLocation"
    >
    </customer-locations-map>
  </div>
</template>
<script>
  import moment from 'moment';
  import axios from '@/plugins/axios';

  import MixinHelpers from '@/mixins/helpers';
  import MixinGlobal from '@/mixins/global';
  import numbersFormats from '@/mixins/numbersFormats';
  import dates from '@/mixins/dates';
  import { Roles } from '@/core/constants/roleConstants';

  import CustomerLocationsMap from '@/components/modals/customers_locations_map/CustomerLocationsMap.vue';
  import ChangePasswordControl from '@/components/ChangePasswordControl.vue';
  import DataUpdateStepLauncher from '@/template/partials/stepsAfterLogin/DataUpdateStepLauncher.vue';
  import SalesPolicyFileDownloader from '@/components/policies/SalesPolicyFileDownload.vue';
  import AlertProminent from '@/components/AlertProminent.vue';
  import SvgIcon from '@/components/icons/SvgIcon.vue';
  import IUSATraining from '@/components/icons/IUSATraining.vue';
  import SalesPerCapita from '@/views/daily/components/SalesPerCapita.vue';

  export default {
    name: 'ManagerCard',
    components: {
      AlertProminent,
      CustomerLocationsMap,
      ChangePasswordControl,
      DataUpdateStepLauncher,
      SalesPolicyFileDownloader,
      SvgIcon,
      IUSATraining,
      SalesPerCapita,
    },
    mixins: [numbersFormats, MixinHelpers, MixinGlobal, dates],
    props: {
      manager: {
        type: Object,
        default: () => ({
          error: '',
          data: '',
          loading: true,
        }),
      },
    },
    data: () => ({
      customersLocation: [],
      today: moment().format('YYYY-MM-DD'),
      openMap: false,
      typeCustomerLocation: 'byManager',
    }),
    computed: {
      isManager() {
        return this.$hasAnyRole([Roles.MANAGER, Roles.SUB_MANAGER]);
      },
      seniorityIUSA() {
        if (this.manager.data.seniority) {
          return this.countMonthsUpToToday(
            this.manager.data.seniority,
            'YYYY-MM-DD'
          ).text.text;
        }
        return 'N/A';
      },
    },
    watch: {
      openMap() {
        if (!this.openMap) {
          this.customersLocation = [];
        }
      },
    },
    methods: {
      async getCustomersLocation() {
        try {
          this.openMap = true;
          let response = await axios.get(
            '/geolocation-map/coordinates-customers',
            {
              params: {
                inicio: this.today,
                fin: this.today,
                P_VTWEG: this.manager.data?.user?.channel,
                P_VKORG: this.manager.VKORG,
                employee_number: this.manager.data?.user?.id,
                type: this.typeCustomerLocation,
              },
            }
          );
          this.customersLocation = response.data;
        } catch (error) {
          this.$toast.error('Ocurrió un error al abrir el documento');
          this.openMap = false;
        }
      },
    },
  };
</script>
